import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import BasicLayout from './layouts/BasicLayout';
import Home from './pages/Home';
import Archive from './pages/Archive';
import Faq from './pages/archive/Faq';
import Notice from './pages/archive/Notice';
import Related from './pages/archive/Related';
import Info from './pages/Info';
import AboutAdjuster from './pages/info/AboutAdjuster';
import Legal from './pages/info/Legal';
import Range from './pages/info/Range';
import Types from './pages/info/Types';
import Performance from './pages/Performance';
import Disasters from './pages/performance/Disasters';
import Portfolio from './pages/performance/Portfolio';
import Profile from './pages/Profile';
import AboutUs from './pages/profile/AboutUs';
import Greetings from './pages/profile/Greetings';
import Map from './pages/profile/Map';
import Organization from './pages/profile/Organization';
import Partner from './pages/profile/Partner';
import Promise from './pages/profile/Promise';
import Proposal from './pages/Proposal';
import Necessity from './pages/proposal/Necessity';
import AdjProcess from './pages/proposal/AdjProcess';
import ClaimGuide from './pages/proposal/ClaimGuide';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path='' element={<BasicLayout />}>
          <Route index element={<Home />}/>
          <Route path='profile' element={<Profile />}>
            <Route index element={<Navigate to="greetings" replace />} />
 
            <Route path='greetings' element={<Greetings />}/> 
            <Route path='promise' element={<Promise />}/>
            <Route path='organization' element={<Organization />}/>
            <Route path='map' element={<Map />}/>
          </Route>
          <Route path='info' element={<Info />}>
            <Route index element={<Navigate to="about-adjust" replace />} />

            <Route path='about-adjust' element={<AboutAdjuster />}/>
            <Route path='types' element={<Types />}/>
            <Route path='range' element={<Range />}/>
            <Route path='legal' element={<Legal />}/>
          </Route>
          <Route path='performance' element={<Performance />}>
            <Route index element={<Navigate to="portfolio" replace />} />

            <Route path='portfolio' element={<Portfolio />}/>
            <Route path='disasters' element={<Disasters />}/>
          </Route>
          <Route path='proposal' element={<Proposal />}>
            <Route index element={<Navigate to="necessity" replace />} />

            <Route path='necessity' element={<Necessity />}/>
            <Route path='adj-process' element={<AdjProcess />}/>
            <Route path='claim-guide' element={<ClaimGuide />}/>
          </Route>
          <Route path='archive' element={<Archive />}>
            <Route index element={<Navigate to="faq" replace />} />
            <Route path='faq' element={<Faq />}/>
            <Route path='notice' element={<Notice />}/>
            <Route path='notice/:id' element={<Notice />} />
            <Route path='notice/*' element={<Navigate to="/archive/notice" replace />} />
            <Route path='related' element={<Related />}/>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
